import { render, staticRenderFns } from "./RImagePicker.vue?vue&type=template&id=70ffa7ee&"
import script from "./RImagePicker.vue?vue&type=script&lang=js&"
export * from "./RImagePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports